module.exports = __webpack_public_path__ + "static/banner-e7ea280ec601e0d0f838ea9c9dbfe5af.jpg";